<template>
  <div class="is-principal-content">
    <app-header/>
    <router-view/>
  </div>
</template>

<script>
import Header from '@/components/general/Header.vue';

export default {
  components: {
    appHeader: Header,
  },
};
</script>
